export default "__VITE_ASSET__CtPni9GX__"